<div
  class="p-24 bg-white rounded-2xl mb-32 relative overflow-hidden md:border md:border-eggplant-100/[0.25] max-w-[1256px] mx-auto">

  <div class="flex flex-col md:flex-row relative z-10 w-full justify-between gap-16 md:gap-0">

    <!-- Loop items -->
    <div *ngFor="let stage of detailProject.postal_code_investment_stages; let i = index; let last = last;"
      class="flex flex-row md:flex-col gap-16 md:gap-6 flex-1 w-full relative group">

      <!-- Linea conectora Desktop (Per Item) -->
      <div class="hidden md:block absolute top-[16px] left-0 md:left-16 z-0" [ngClass]="{
                'w-[calc(100%-16px)]': last,
                'w-full': !last
              }">
        <div class="w-full" [ngClass]="{
                'border-t-2 border-dashed border-gray-10': isStagePassed(i),
                'h-[2px] bg-orange-100': !isStagePassed(i)
              }">
        </div>
      </div>

      <!-- Linea conectora Mobile (vertical) -->
      <div class="md:hidden absolute left-[15px] top-[28px] bottom-[-24px] w-[2px]"
        [ngClass]="isStagePassed(i) ? 'border-l-2 border-dashed border-gray-10' : 'bg-orange-100'">
      </div>

      <!-- Marker -->
      <div class="relative z-10">
        <div class="w-32 h-32 md:bg-white rounded-full flex items-center justify-center">
          <div class="w-12 h-12 md:w-16 md:h-16 rounded-full"
            [ngClass]="isStagePassed(i) ? 'bg-gray-10' : 'bg-orange-100'">
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="flex flex-col pt-4 w-full md:pl-12 mb-12 md:mb-0">
        <div class="flex gap-6 py-6 mb-12 items-center md:justify-center rounded-xl w-fit"
          [ngClass]="{'bg-gradient-1': isStageActive(i), 'bg-success/[0.55]' : isStagePassed(i), 'px-12': (isStageActive(i) || isStagePassed(i))}">
          <fun-icon [name]="isStagePassed(i) ? 'check-circle' : isStageActive(i) ? 'users' : 'clock'"
            [style]="'w-32 h-32 stroke-[4px] ' + (isStagePassed(i) || isStageActive(i) ? 'stroke-white' : 'stroke-orange-100')"></fun-icon>
          <p class="font-sans text-xl"
            [ngClass]="isStagePassed(i) || isStageActive(i) ? 'text-white' : 'text-orange-100'">
            {{ isStagePassed(i) ? 'Completada' : isStageActive(i) ? 'Fase Actual' : 'Próximamente' }}
          </p>
        </div>
        <span class="text-s font-sans tracking-wider uppercase"
          [ngClass]="isStageActive(i) ? 'text-eggplant-100/[0.55]' : 'text-gray-25'">
          {{ stage.start_date | date:'dd/MM/yyyy' }}
        </span>
        <h3 class="text-base font-sans text-xl" [ngClass]="isStageActive(i) ? 'text-eggplant-80' : 'text-gray-25'">
          {{ stage.title }}
        </h3>
        <p class="text-m font-sans max-w-[320px]" [ngClass]="isStageActive(i) ? 'text-eggplant-80' : 'text-gray-25'">
          {{ stage.description }}
        </p>

        <div *ngIf="stage.priority_groups && stage.priority_groups.length > 0" class="flex flex-col gap-2 mt-4">

          <ng-container *ngIf="hasUserPriorityGroup(stage)">
            <div class="flex gap-6 items-center pb-12">
              <fun-icon [name]="'check-circle'" [style]="'w-12 h-12 stroke-[4px] stroke-verified'"></fun-icon>
              <p class="font-sans text-s text-verified">
                Tienes vinculación con un grupo prioritario de esta fase.
              </p>
            </div>
          </ng-container>

          <!-- De momento comento el CTA que saca la modal de probar mi vinculacion a un grupo prioritario
          <ng-template #noPriorityGroup>
            <div class="pt-12">
              <fun-new-button size="s" icon="" iconPosition="" buttonType="primaryDark" (eventClick)="vinculate(stage)"
                title="Probar mi vinculación a un grupo prioritario"></fun-new-button>
            </div>
          </ng-template> -->

          <div
            class="flex gap-4 items-center cursor-pointer hover:opacity-80 transition-opacity w-fit text-orange-100 pt-12"
            (click)="viewDetails(stage)">
            <fun-icon [name]="'eye'" [style]="'w-20 h-20 stroke-[4px] stroke-orange-100'"></fun-icon>
            <p class="font-sans text-l">Ver grupos prioritarios</p>
          </div>

        </div>

        <div *ngIf="stage.type === 1" class="pt-12">
          <fun-new-button size="s" icon="" iconPosition=""
            [buttonType]="isStageActive(i) ? 'secondaryDark' : 'secondaryDark-disabled'" title="Reservar mi inversión"
            (eventClick)="bookInvestment()"></fun-new-button>
        </div>

      </div>
    </div>
  </div>
</div>